export const MODAL_TYPE_CONFIGURATION = "MODAL_TYPE_CONFIGURATION";
export const MODAL_TYPE_NOTIFICATION = "MODAL_TYPE_NOTIFICATION";
export const MODAL_TYPE_CONFIRMATION = "MODAL_TYPE_CONFIRMATION";
export const MODAL_TYPE_BROADCASTSUMMARY = "MODAL_TYPE_BROADCASTSUMMARY";
export const MODAL_TYPE_PLATFORM_SETTINGS = "MODAL_TYPE_PLATFORM_SETTINGS";
